import type { ChatMessage, Thread } from "../features/messaging/model";
import API, { responseOf } from "./base";

export const getThreadMessages = (threadId: string): Promise<ChatMessage[]> =>
  responseOf(API.get(`/chats/${threadId}/messages`));

export const sendMessage = (
  threadId: string,
  message: ChatMessage,
): Promise<ChatMessage> =>
  responseOf(API.post(`/chats/${threadId}/messages`, message));

export const getChatsForSubject = (subjectId: string): Promise<Thread[]> =>
  responseOf(API.get(`/chats/byProcessExecutionId/${subjectId}`));
